module.exports = __webpack_public_path__ + "img/optimism.caeb9392.svg";